const EXCLUDE_ATTR = []
const NewArrayFormatAttr = ['IMAGE', 'CERTIFICATE']
const EditArrayFormatAttr = ['CERTIFICATE']
export default {
  submitTemplateFormat(data) {
    data.forEach(item => {
      if (['TRACING_PLAT_INFO', 'TRACING_BREED_INFO', 'TRACING_WORK_INFO', 'INSPECT_REPORT'].indexOf(item.type) > -1) {
        item.fieldValue = item.fieldValue || 0
      }
      switch (item.type) {
          case 'DATE':
            item.fieldValue = +item.fieldValue
            break
          case 'IMAGE':
            item.fieldValue = item.fieldValue.map(item => item.url).join(',')
            break
          case 'CERTIFICATE':
            item.fieldValue = item.fieldValue.join(',')
            break
          case 'PRODUCTION_DATE':
            item.fieldValue = item.checked ? 0 : +item.fieldValue
            delete item.checked
            break
          default:
            break
      }
      if (item.type === 'NUMBER2TIMEUNIT' && item.name === 'shelflife') {
        item.fieldValue = item.checked ? 0 : +item.fieldValue
        delete item.checked
      }
      // if (item.type.indexOf('NUMBER') > -1) {
      //   item.fieldValue = item.fieldValue === undefined ? null : item.fieldValue
      // }
    })
    return data
  },
  newTemplateFormat(data) {
    const result = data.filter(item => item.display && !item.fixedField && EXCLUDE_ATTR.indexOf(item.type) === -1)
    result.forEach(item => {
      if (NewArrayFormatAttr.indexOf(item.type) > -1) {
        item.fieldValue = []
      }
      if (item.unitEnumValues.length) {
        item.unitFieldValue = item.unitEnumValues[0].value
      }
      if (item.type === 'PRODUCTION_DATE') {
        item.checked = item.fieldValue === '0'
        item.fieldValue = item.fieldValue === '0' || !item.fieldValue ? null : new Date(+item.fieldValue)
      }
      if (item.type === 'NUMBER2TIMEUNIT' && item.name === 'shelflife') {
        item.checked = item.fieldValue === '0'
        item.fieldValue = item.fieldValue === '0' || !item.fieldValue ? null : +item.fieldValue
      }
      // if (item.type.indexOf('NUMBER') > -1) {
      //   item.fieldValue = item.fieldValue === null ? undefined : item.fieldValue
      // }
    })
    return result
  },
  editTemplateFormat(data) {
    const result = data.filter(
      item => item.display && !item.fixedField && EXCLUDE_ATTR.indexOf(item.type) === -1)
    result.forEach(item => {
      if (item.type === 'IMAGE') {
        item.fieldValue = item.fieldValue ? item.fieldValue.split(',').map(item => ({ url: item })) : []
      }
      if (item.type === 'DATE') {
        item.fieldValue = item.fieldValue ? new Date(+item.fieldValue) : null
      }
      if (item.type === 'PRODUCTION_DATE') {
        item.checked = item.fieldValue === '0'
        item.fieldValue = item.fieldValue === '0' || !item.fieldValue ? null : new Date(+item.fieldValue)
      }
      if (item.type === 'NUMBER2TIMEUNIT' && item.name === 'shelflife') {
        item.checked = item.fieldValue === '0'
        item.fieldValue = item.fieldValue === '0' || !item.fieldValue ? null : +item.fieldValue
      }
      if (['TRACING_PLAT_INFO', 'TRACING_BREED_INFO', 'TRACING_WORK_INFO', 'INSPECT_REPORT'].indexOf(item.type) > -1) {
        item.fieldValue = item.fieldValue ? +item.fieldValue : item.fieldValue
      }
      if (EditArrayFormatAttr.indexOf(item.type) > -1) {
        item.fieldValue = item.fieldValue ? item.fieldValue.split(',').map(item => +item) : []
      }
      // if (item.type.indexOf('NUMBER') > -1) {
      //   item.fieldValue = item.fieldValue === null ? undefined : item.fieldValue
      // }
    })
    return result
  }
}
